export function errorDialog ({
  name,
  code,
  fileName,
  errorTips,
  url,
  isDark,
  isMac,
}) {
  let openUrl = "";
  if (url) {
    if (isMac) {
      // openUrl = "javascript:window.open('" + url + "')";
      openUrl = `href="javascript:window.open('${url}','_blank')"`;
      // openUrl = `href="javascript:window.open('https://www.baidu.com','_blank')"`;
    } else {
      openUrl = `target="_blank" href="${url}"`;
    }
  }
  return `
    <body>
      <div class="errorDialog">
        <div class="top">
          <div class="name">${name}</div>
          <div class="code">Code: ${code}</div>
        </div>
          ${fileName
      ? `
            <div class="fileName">
              ${fileName}
            </div>
            `
      : ""
    }
        <div class="main-tips">
          <img
            src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Imhtc19ub3RpZnlfbHYyIj4KPHBhdGggaWQ9IlZlY3RvciIgZD0iTTE2Ljc2NDkgMTMuMjczMUwxMC40OTk5IDEuOTA5MDdDMTAuMzU1NCAxLjYzNTcgMTAuMTM5MSAxLjQwNjkxIDkuODc0MjYgMS4yNDczM0M5LjYwOTQyIDEuMDg3NzUgOS4zMDYwOCAxLjAwMzQyIDguOTk2ODcgMS4wMDM0MkM4LjY4NzY3IDEuMDAzNDIgOC4zODQzMyAxLjA4Nzc1IDguMTE5NDkgMS4yNDczM0M3Ljg1NDY1IDEuNDA2OTEgNy42MzgzNSAxLjYzNTcgNy40OTM4OCAxLjkwOTA3TDEuMjM0ODggMTMuMjczMUMxLjA3ODMgMTMuNTQ0MyAwLjk5NDQwNSAxMy44NTEzIDAuOTkxMyAxNC4xNjQ1QzAuOTg4MTk1IDE0LjQ3NzYgMS4wNjU5OSAxNC43ODYzIDEuMjE3MTUgMTUuMDYwNUMxLjM2ODMxIDE1LjMzNDggMS41ODc3MiAxNS41NjU0IDEuODU0MTQgMTUuNzNDMi4xMjA1NiAxNS44OTQ2IDIuNDI0OTYgMTUuOTg3NiAyLjczNzg4IDE2LjAwMDFIMTUuMjYxOUMxNS41NzQ4IDE1Ljk4NzYgMTUuODc5MiAxNS44OTQ2IDE2LjE0NTYgMTUuNzNDMTYuNDEyIDE1LjU2NTQgMTYuNjMxNCAxNS4zMzQ4IDE2Ljc4MjYgMTUuMDYwNUMxNi45MzM4IDE0Ljc4NjMgMTcuMDExNiAxNC40Nzc2IDE3LjAwODUgMTQuMTY0NUMxNy4wMDUzIDEzLjg1MTMgMTYuOTIxNCAxMy41NDQzIDE2Ljc2NDkgMTMuMjczMVoiIGZpbGw9IiNGRjZGMDAiLz4KPHBhdGggaWQ9IlZlY3Rvcl8yIiBkPSJNMTAgMTFIOFY0SDEwVjExWk0xMCAxMkg4VjE0SDEwVjEyWiIgZmlsbD0iI0U2RTZFNiIvPgo8L2c+Cjwvc3ZnPgo="
            alt="">
          <span class="tips">${errorTips}</span>
          ${openUrl &&
    `<a ${openUrl} style="display: flex;align-items:flex-end">Wiki</a>`
    }
        </div>
      </div>
    </body>
    <style>
      body {
        margin: 0;
        background-color: ${isDark ? "#2D2D31" : "#FFFFFF"};
      }

      .errorDialog {
        background-color: ${isDark ? "#36363B" : "#F5F5F5"};
        border-radius: 7px;
        padding: 13px 10px 11px 14px;
      }

      .top{
        display: flex;
        justify-content: space-between;
      }

      .name {
        max-width: 285px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        font-size: 14px;
        color: ${isDark ? "#FFFFFE" : "#000000"};
        line-height: 16px;
      }

      .code {
        float: right;
        color: #FF3A34;
        font-size: 13px;
        line-height: 15px;
      }

      .fileName {
        margin-top: 2px;
        font-size: 13px;
        color: ${isDark ? "#B3B3B5" : "#6B6B6A"};
        line-height: 18px;
        display: -webkit-box;
        word-break: break-all;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .main-tips {
        margin-top: 12px;
        display: flex;
      }

      .tips {
        margin:0 4px;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 13px;
        color: ${isDark ? "#FFFFFE" : "#000000"};
      }
    </style>
  `;
}

export function successDiv ({ name, fileName, successTip, isDark, modelImg }) {
  return `
    <body>
      <div class="successDialog">
        <div class="mainTitle">
          <img
            class="modelImg"
            src="${modelImg}"
            alt="">
          <div style="width: 290px;">
            ${fileName
      ? `
            <div class="fileName">
              ${fileName}
            </div>
            `
      : ""
    }
            <div class="name">${name}</div>
            <div class="main-tips" style="margin-top: 12px;display: flex;">
              <img
                src="data:image/svg+xml;base64,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"
                alt="">
              <span class="tips">${successTip}</span>
            </div>
          </div>
        </div>
      </div>
    </body>
    <style>
      body {
        margin: 0;
        background-color: ${isDark ? "#2D2D31" : "#FFFFFF"};
      }

      .mainTitle {
        background-color: ${isDark ? "#36363B" : "#F5F5F5"};
        border-radius: 7px;
        padding: 10px;
        margin-bottom: 18px;
        display: flex;
      }

      .successDialog {
        background-color: ${isDark ? "#36363B" : "#F5F5F5"};
        border-radius: 7px;
      }

      .modelImg {
        width: 96px;
        height: 74px;
        object-fit: cover;
        margin-right: 12px;
        flex: none;
      }

      .fileName {
        line-height: 16px;
        height: 20px;
        font-size: 14px;
        color: ${isDark ? "#FFFFFE" : "#000000"};
        display: -webkit-box;
        word-break: break-all;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      
      .name {
        height: 18px;
        line-height: 15px;
        margin-top: 2px;
        font-size: 13px;
        color: ${isDark ? "#B3B3B5" : "#6B6B6A"};
        max-width: 290px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .main-tips {
        margin-top: 12px;
        display: flex;
        align-items: center;
      }

      .tips {
        margin:0 4px;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 13px;
        color: ${isDark ? "#FFFFFE" : "#000000"};
      }
    </style>
  `;
}
export function successDivProjectInfo ({
  name,
  fileName,
  successTip,
  isDark,
  projectInfo: {
    is_markonline_file,
    common_comment_point,
    markonline_comment_direct_point,
    markonline_comment_photo_point,
    web_markonline_comment_url,
    project_id,
    official_file_id,
  },
  submitTips: {
    print_quality_score,
    submit,
    submitted,
    review_makeronlie,
    extra,
    submission_failed_retry,
  },
  baseUrl,
  modelImg,
  isMac
}) {
  const getFileName = fileName
    ? `<div class="fileName">${fileName}</div>`
    : ""
  const getName = name
      ? `<div class="name">${name}</div>`
    : ""
  let openUrl = "";
  if (web_markonline_comment_url) {
    if (isMac) {
      // openUrl = "javascript:window.open('" + url + "')";
      openUrl = `href="javascript:window.open('${web_markonline_comment_url}','_blank')"`;
      // openUrl = `href="javascript:window.open('https://www.baidu.com','_blank')"`;
    } else {
      openUrl = `target="_blank" href="${web_markonline_comment_url}"`;
    }
  }
  return `
  <style>
    body {
      margin: 0;
      background-color: ${isDark ? "#2D2D31" : "#FFFFFF"};
    }

    .mainTitle {
      background-color: ${isDark ? "#36363B" : "#F5F5F5"};
      border-radius: 7px;
      padding: 13px 10px 11px 14px;
      margin-bottom: 18px;
      display: flex;
    }

    .modelImg {
      width: 96px;
      height: 74px;
      object-fit: cover;
      margin-right: 12px;
      flex: none;
    }

    .fileName {
      font-size: 14px;
      color: ${isDark ? "#FFFFFE" : "#000000"};
      line-height: 18px;
      display: -webkit-box;
      word-break: break-all;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    
    .name {
      margin-top: 2px;
      font-size: 13px;
      color: ${isDark ? "#B3B3B5" : "#6B6B6A"};
      line-height: 18px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .tips {
      margin:0 4px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: ${isDark ? "#FFFFFE" : "#000000"};
    }

    .ratingTips {
      margin-left: 14px;
      font-weight: normal;
      font-size: 13px;
      color: ${isDark ? "#B3B3B5" : "#6B6B6A"};
      line-height: 24px;
    }

    .sumbitBtn {
      margin-left: 8px;
    }
    .sumbitTips{
      display: none;
    }

    .sumbitBtn button {
      padding: 4px 16px 2px 16px;
      border-radius: 14px;
      background: #438DFF;
      border: none;
      font-weight: normal;
      font-size: 13px;
      color: #FFFFFF;
      line-height: 18px;
      cursor: pointer;
    }

    .disabled {
      opacity: .4;
    }

    .disabled button {
      cursor: default;
    }

    .rating {
      float: right;
      display: flex;
      cursor: pointer;
    }

    .star {
      font-size: 24px;
      height: 24px;
      width: 24px;
      background: url('data:image/webp;base64,UklGRuoCAABXRUJQVlA4WAoAAAAwAAAAFwAAFwAASUNDUMgBAAAAAAHIAAAAAAQwAABtbnRyUkdCIFhZWiAH4AABAAEAAAAAAABhY3NwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAA9tYAAQAAAADTLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlkZXNjAAAA8AAAACRyWFlaAAABFAAAABRnWFlaAAABKAAAABRiWFlaAAABPAAAABR3dHB0AAABUAAAABRyVFJDAAABZAAAAChnVFJDAAABZAAAAChiVFJDAAABZAAAAChjcHJ0AAABjAAAADxtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAAgAAAAcAHMAUgBHAEJYWVogAAAAAAAAb6IAADj1AAADkFhZWiAAAAAAAABimQAAt4UAABjaWFlaIAAAAAAAACSgAAAPhAAAts9YWVogAAAAAAAA9tYAAQAAAADTLXBhcmEAAAAAAAQAAAACZmYAAPKnAAANWQAAE9AAAApbAAAAAAAAAABtbHVjAAAAAAAAAAEAAAAMZW5VUwAAACAAAAAcAEcAbwBvAGcAbABlACAASQBuAGMALgAgADIAMAAxADZWUDhM+wAAAC8XwAUQ94Cgbdsk288f6DG8pYGgbdsk288f6DG8RdC2bZLt5w/0GN4yiiRJcXQhl+HueU4ugNDWe6/fe+2umfH/36oku+1WJflmpifpKhXwtu0AgKotwMxkQJKi/irgbQsAiI0kKZLimJmp/fdz8O7fgIj+K3DbRukYju8VAAAAAAAAAAAAAFitO2Xy/kz7cIw4d9qI96TTRhxbtdF8tX8nvPer+bD0ds+IiIiIiNT62uY4RbT4kGNwa8l9UJmhlHKCJlcnKYrZ6GxwY6pxTY3rWNSwrGOTxn4+aVxxaZWr+1wmk+M74lLHI67Z284e8Wi0ZC+eOaN/9skAAA==');
    }

    .star.selected {
      background: url('data:image/webp;base64,UklGRt4EAABXRUJQVlA4WAoAAAAwAAAAFwAAFwAASUNDUMgBAAAAAAHIAAAAAAQwAABtbnRyUkdCIFhZWiAH4AABAAEAAAAAAABhY3NwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAA9tYAAQAAAADTLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlkZXNjAAAA8AAAACRyWFlaAAABFAAAABRnWFlaAAABKAAAABRiWFlaAAABPAAAABR3dHB0AAABUAAAABRyVFJDAAABZAAAAChnVFJDAAABZAAAAChiVFJDAAABZAAAAChjcHJ0AAABjAAAADxtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAAgAAAAcAHMAUgBHAEJYWVogAAAAAAAAb6IAADj1AAADkFhZWiAAAAAAAABimQAAt4UAABjaWFlaIAAAAAAAACSgAAAPhAAAts9YWVogAAAAAAAA9tYAAQAAAADTLXBhcmEAAAAAAAQAAAACZmYAAPKnAAANWQAAE9AAAApbAAAAAAAAAABtbHVjAAAAAAAAAAEAAAAMZW5VUwAAACAAAAAcAEcAbwBvAGcAbABlACAASQBuAGMALgAgADIAMAAxADZWUDhM8AIAAC8XwAUQ9wS7tm1VzTl3v/cu7i5/3gVNUA+DemiCBty+3F3jyZNYEQjato3b84f8DpJt26ar/XBi27bqKSVNS/qVkbLtIr/N5+e4bSRHDlLdc979j2yAojC5hIB1iOiqulV0kI6abWVQ91xJW8Nddu9pfjqyTRrsCaWInTm7ElPYC3pDPO4e83PbuJ8Aa8ThmZIHvFByA8HUO37eKDn9IlYO0DUYO4uIfIJ++0RJIFCf/mMUUyNGBqygpWIvz56PxpMKDMy8ec3Og+kxLRN2Zngymq0diygf0I9JHYBXP087Gwv28E/hgZMrv7BXwjJtJPN53uvo5KxiV1uX1rgYhEXZdHqG/5fkXIze9lr11zvJVkmWx2nXddSWPjk7++qVrqvbVUxrNEajm1wDIjcjistdV+DphKPO0ifhGmuOgvsTXMDwkyxkLCY3K5xkk03yxC+uRMbS8PrppwS8T38DBAgQBkAIA3gKQhiPPFMQIIQBPMIAHoOf379lOsIQCAMgDATCAAgQCgMSJMk2bauebdu2bdvftu1r2/f8fR/nyn3fECL6r8BtG2XMh68AAAAAAAAAAAAAAAAAAAAAAAAAAABW1pMTbsT1X38P5ybeBO6cnj1vz4yNzrVfTk5+zVYlRYfbx0fHR8+6MuSquG/51udI5DDy/f7mUGFcbMwVa/ejEP+FEEIIIYQQn/Yyky6Ne0FFCSlKMKyELicpyuO2nASIyXji9wf8gUAgEAj4/f7Ah/nh8ssLTKp46PX6vD7fefzSe7k63Z1zJZ1W+8jtcbtdbpPbY361Ot1TdHGtV6jpm9HpcBiNTsfPtZlzltx2o95u0OttNpvetjFYInuEcZ1Vp9NadTqd9qA3W3al2xqNxvLvj0aj0TwYKIiRwF21+u+7na0XP9TqN2OlMvFU9Xp/YXq0f+mt6v1EtSzcMDk1PdJamlfdvTg3Vid7y5TKzpay9PjY5KyajuZ82W+JSc1IT7g8ZmxSenqUp5dt7Uo3');
    }

    .sumbitTip1 {
      float: left;
      margin-left: 14px;
      font-weight: normal;
      font-size: 13px;
      color: ${isDark ? '#B3B3B5' : '#6B6B6A'};
      line-height: 24px;
    }
    .sumbitTip3 {
      text-align: right;
      width: 100%;
      font-weight: normal;
      font-size: 13px;
      color: #FF524D;
      line-height: 18px;
    }

    .sumbitTip2 {
      float: right;
      font-weight: normal;
      font-size: 13px;
      line-height: 15px;
      display: ${is_markonline_file ? "black" : "none"};
      margin: 2px 4px 0;
      color: #398DFF;
    }
    .errorTips{
      display: none;
      margin: 0;
    }

    #currentRating {
      margin-top: 20px;
      font-size: 24px;
    }

    .ratingEdit {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .score {
      display: flex;
    }

    .main-tips {
      margin-top: 12px;
      display: flex;
      align-items: center;
      .tips {
        font-size: 13px;
        height: 18px;
      }
    }

    </style>
    <body>
      <div class="successDialog">
        <div class="mainTitle">
          <img
            class="modelImg"
            src="${modelImg}"
            alt="">
          <div style="width:290px;">
              ${getFileName}
              ${getName}
            <div class="main-tips">
              <img
                src="data:image/svg+xml;base64,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"
                alt="">
              <span class="tips">${successTip}</span>
            </div>
          </div>
        </div>
        <div class="ratingEdit btn">
          <div class="ratingTips">${print_quality_score}</div>
          <div>
            <div class="score">
              <div class="rating" id="rating">
                <span class="star" data-value="1"></span>
                <span class="star" data-value="2"></span>
                <span class="star" data-value="3"></span>
                <span class="star" data-value="4"></span>
                <span class="star" data-value="5"></span>
              </div>
              <div class="sumbitBtn disabled">
                <button>${submit}</button>
              </div>
              <div class="sumbitTips tips">
                <div class="sumbitTip1">${submitted}</div>
              </div>
            </div>
            <a ${openUrl} class="sumbitTip2">${review_makeronlie}</a>
            <div class="ratingBox errorTips tips">
              <div class="sumbitTip3">${submission_failed_retry}</div>
            </div>
          </div>
        </div>
      </div>
    </body>
    <script>
      const stars = document.querySelectorAll('.star');

      const sumbitBtn = document.querySelectorAll('.sumbitBtn')[0]
      const sumbitTips = document.querySelectorAll('.sumbitTips')[0]
      const errorTips = document.querySelectorAll('.errorTips')[0]
      const urlEle= document.querySelectorAll('.sumbitTip2')[0]

      let val = null
      let faild = false
      let isSumbit = false

      stars.forEach(star => {
        star.addEventListener('click', ()=>{
          if(isSumbit) return
          const ratingValue = star.getAttribute('data-value');
          sumbitBtn.className = 'sumbitBtn'
          sumbitBtn.style.cursor = 'pointer'
          val = ratingValue

          // 更新星星样式
          stars.forEach(s => {
            s.classList.remove('selected');
          });
          for (let i = 0; i < ratingValue; i++) {
            stars[i].classList.add('selected');
          }
        });
      });

      async function sendHttp(url,method,body,headres){
        return fetch(url, {
            method: method,
            body: JSON.stringify(body), // 将 JavaScript 对象转换为 JSON 字符串
            headers:{
              'content-type': 'application/json',
              ...headres
            }
           })
      };
      async function sendRequest(url,method,body,headers){
        let response = ${isMac}
          ? await fetch('anycubic://localhost/api/v1/account/headers')
          : await fetch('http://ac.localhost/api/v1/account/headers')
        const { data } = await response.json()
        // modity param headers
        // modity param url

        let cururl = new URL(url)
        cururl.host = data.host;
        url = cururl.href

        if (data.status == 1) {
          Object.keys(data.headers).forEach((key) => {
            headers[key] = data.headers[key]
          })
        }
        return sendHttp(url,method,body,headers)
      }

      sumbitBtn.addEventListener('click', async () => {
        if ([...stars].some(item => item.className == 'star selected')) {
          if(faild){
            return
          } else {
            faild = true
          }

          //  增加逻辑，mac需要请求请求头服务
          const response = await sendRequest('https://localhost${baseUrl}/v3/work/sumbitComment','POST',{
              project_id: ${project_id},
              star: Number(val)
            },{})
          const res = await response.json()
          faild = false

          //  Dom处理
          sumbitTips.style.display = 'block'
          sumbitBtn.style.display = 'none'
          urlEle.style.display = 'none'
          isSumbit = true
          

          if(res.code == 1){
            // document.querySelectorAll('a')[0].href = document.querySelectorAll('a')[0].href + '%26score%3D' + val
            errorTips.style.display = 'none'
          } else if(res.code == 0) {
            document.querySelectorAll('.sumbitTip3')[0].innerText = res.msg
            errorTips.style.display = 'block'
          } else {
            errorTips.style.display = 'block'
          }
        }
      })
    </script>
  `;
}

//             <div class="sumbitTip2"><a target="_blank" style="margin: 0 4px; color: #398DFF" href="${web_markonline_comment_url}">${review_makeronlie}</a>${extra} +${markonline_comment_photo_point} ${points}</div>
